export * from './modules/Pictures/action-types'

export const FETCH_PARTS = 'FETCH_PARTS'
export const FETCH_PARENT = 'FETCH_PARENT'
export const FETCH_VEHICLE_SPECIFICATIONS = 'FETCH_VEHICLE_SPECIFICATIONS'
export const FETCH_PART_VEHICLE_SPECIFICATIONS = 'FETCH_PART_VEHICLE_SPECIFICATIONS'
export const FETCH_PART_WHEEL_SPECIFICATIONS = 'FETCH_PART_WHEEL_SPECIFICATIONS'
export const FETCH_PART_CATEGORY_KINDS = 'FETCH_PART_CATEGORY_KINDS'
export const FETCH_WHEEL_SPECIFICATIONS = 'FETCH_WHEEL_SPECIFICATIONS'
export const SEARCH_PART_CATEGORIES = 'SEARCH_PART_CATEGORIES'
export const FETCH_PART_CATEGORIES = 'FETCH_PART_CATEGORIES'
export const FETCH_MODELS = 'FETCH_MODELS'
export const FETCH_MODIFICATIONS = 'FETCH_MODIFICATIONS'
export const FETCH_ENGINES = 'FETCH_ENGINES'
export const CREATE_PART = 'CREATE_PART'
export const DELETE_PART = 'DELETE_PART'
export const FETCH_PART = 'FETCH_PART'
export const FETCH_GROUPED_SALES = 'FETCH_GROUPED_SALES'
export const EDIT_PART = 'EDIT_PART'
export const HANDOVER_ORDER_PARTS = 'HANDOVER_ORDER_PARTS'
export const FETCH_PARTS_SEARCH_SUGGESTIONS = 'FETCH_PARTS_SEARCH_SUGGESTIONS'
export const FETCH_CATEGORY_SET = 'FETCH_CATEGORY_SET'
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS'
export const DELETE_PARTS = 'DELETE_PARTS'
export const FETCH_INPUT_PART_SEARCH_SUGGESTIONS = 'FETCH_INPUT_PART_SEARCH_SUGGESTIONS'
export const CREATE_PART_CATEGORY = 'CREATE_PART_CATEGORY'
export const FETCH_PART_PHOTOS = 'FETCH_PART_PHOTOS'
export const FETCH_EXTERNAL_ITEMS = 'FETCH_EXTERNAL_ITEMS'
export const DETACH_PARTS = 'DETACH_PARTS'
export const EDIT_PART_PRICE = 'EDIT_PART_PRICE'
export const REMOVE_PARTS = 'REMOVE_PARTS'
export const FETCH_PART_LOGS = 'FETCH_PART_LOGS'
export const RESTORE_PART = 'RESTORE_PART'
export const FETCH_PART_PARENT = 'FETCH_PART_PARENT'
export const FETCH_PART_TASKS = 'FETCH_PART_TASKS'
export const FETCH_PARTS_META = 'FETCH_PARTS_META'
export const FETCH_PARENT_GROUPED_SALE = 'FETCH_PARENT_GROUPED_SALE'
export const FETCH_PART_CATEGORY_SEARCH_SUGGESTIONS = 'FETCH_PART_CATEGORY_SEARCH_SUGGESTIONS'
export const BULK_UPDATE_PARTS_PRICE = 'BULK_UPDATE_PARTS_PRICE'
export const BULK_UPDATE_PARTS_LOCATION = 'BULK_UPDATE_PARTS_LOCATION'
export const FETCH_SUSPENSION_TYPES = 'FETCH_SUSPENSION_TYPES'
export const REFRESH_SUGGESTED_LOCATION = 'REFRESH_SUGGESTED_LOCATION'
export const FETCH_PART_LOCATIONS = 'FETCH_PART_LOCATIONS'
export const EDIT_WHEEL = 'EDIT_WHEEL'
export const FETCH_PRICE_CHECKER_STATISTICS = 'FETCH_PRICE_CHECKER_STATISTICS'
export const FETCH_PART_AI_SUGGESTED_PRICE = 'FETCH_PART_AI_SUGGESTED_PRICE'
export const FETCH_PART_SALE_OUTLOOK = 'FETCH_PART_SALE_OUTLOOK'
export const FETCH_PRICE_CHECKER_CURRENT_ADS = 'FETCH_PRICE_CHECKER_CURRENT_ADS'
export const FETCH_PRICE_CHECKER_CHANNEL_NAMES = 'FETCH_PRICE_CHECKER_CHANNEL_NAMES'
export const FETCH_RELATED_PARTS = 'FETCH_RELATED_PARTS'
export const FETCH_OEM_FITMENTS = 'FETCH_OEM_FITMENTS'
export const FETCH_VEHICLE_FITMENTS = 'FETCH_VEHICLE_FITMENTS'
export const FETCH_RELATED_FITMENTS = 'FETCH_RELATED_FITMENTS'
export const FETCH_PARTS_STATISTICS = 'FETCH_PARTS_STATISTICS'
export const EXPORT_PARTS = 'EXPORT_PARTS'
export const FETCH_PARTS_DRAFTS = 'FETCH_PARTS_DRAFTS'
export const FETCH_PARTS_DRAFTS_META = 'FETCH_PARTS_DRAFTS_META'

export const GET_VEHICLE_FROM_PLATE_NUMBER = 'GET_VEHICLE_FROM_PLATE_NUMBER'
